import styled from 'styled-components';
import { CommonTitle } from '../../../components/items/common.title';
import { useForm, Controller } from 'react-hook-form';
import { TimeLine } from '../../../components/icon/icon';
import { useState } from 'react';
import DatePicker from 'react-datepicker';
import { TextArea } from '../../../components/items/joinInput';
import { useRecoilValue } from 'recoil';
import { selectedItemsState } from '../../../atoms/orderState';
import { zodResolver } from '@hookform/resolvers/zod';
import { NotificationSchema } from '../../../schema/orderSchema';
import { postOrderNotification } from '../../../api/order';
import { useHistory } from 'react-router';
import { AlertModal } from '../../../components/modal/alert.modal';

const radioBtnItems = [
  { key: '1', value: '도착시간 변경 알림', sub: true },
  { key: '2', value: '부분 수주 취소 알림', sub: false },
  { key: '3', value: '안내문구 알림', sub: true },
  { key: '4', value: '선택 수주 승인 알림', sub: false },
];

const OrderStatusAlert = () => {
  const selectedItems = useRecoilValue(selectedItemsState); // 상태 값을 가져옵니다.
  console.log(selectedItems);

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(NotificationSchema),
  });

  const selectedRadio = watch('radioBtnItems'); // useForm의 watch 사용
  const [startTime, setStartTime] = useState<Date>(new Date());

  // 모달
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [navigateOnClose, setNavigateOnClose] = useState(false); // 페이지 이동 여부를 추적

  const handleModalClose = () => {
    setIsModalOpen(false);
    if (navigateOnClose) {
      history.push({
        pathname: '/managerOrder',
      });
    }
  };

  const onSubmit = async (data: any) => {
    // Create the data for the API request
    const notificationData = selectedItems.map((item) => ({
      orderId: item.orderId,
      obtainId: [parseInt(item.obtainId.toString(), 10)], // 수주 아이디 목록을 숫자로 변환
      target: data.targetTime ? data.targetTime.toISOString() : undefined,
      text: data.notificationTxt || undefined,
      approval: selectedRadio === '4', // '선택 수주 승인 알림'이 선택된 경우 true로 설정
    }));

    // Call the API function for each notification

    try {
      for (const singleNotification of notificationData) {
        const response = await postOrderNotification(singleNotification);
        if (response.statusCode !== 200) {
          throw new Error('Notification failed');
        }
      }
      setModalMessage('발송이 완료되었습니다.');
      setIsModalOpen(true);
      setNavigateOnClose(true);
    } catch (error) {
      console.error('발송 중 오류가 발생했습니다:', error);
      setModalMessage('발송 중 오류가 발생했습니다.');
      setIsModalOpen(true);
      setNavigateOnClose(false);
    }
  };
  return (
    <Container>
      <CommonTitle
        title="알림 선택"
        subTitle="한가지 알림만 선택 가능합니다."
      />
      <AlertWrap>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ul>
            {radioBtnItems.map((item, i: number) => (
              <li key={i}>
                <div className="radio-box">
                  <label className="text" htmlFor={item.key.toString()}>
                    {item.value}
                  </label>
                  <input
                    type="radio"
                    value={item.key}
                    id={item.key.toString()}
                    {...register('radioBtnItems')}
                    // onChange={() => setSelectedRadio(item.key)} // 문자열로 설정
                  />
                  <label
                    className="check-box"
                    htmlFor={item.key.toString()}
                  ></label>
                </div>
                {/* 도착시간 변경 알림이 선택되었을 때만 DatePicker 활성화 */}
                {item.key === '1' && selectedRadio === '1' && (
                  <div className="changearrivalTime-wrapper">
                    <div className="changearrivalTime">
                      <DatePickerContainer>
                        <span>변경 시간</span>
                        <div className="inner">
                          <Controller
                            name="targetTime"
                            control={control}
                            defaultValue={null} // 기본값 설정
                            render={({ field: { onChange, value } }) => (
                              <CustomDatePicker
                                className="search-input"
                                selected={value ? new Date(value) : null}
                                onChange={(date: any) => onChange(date)}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                timeCaption="변경시간"
                                dateFormat="hh:mm aa"
                                withPortal
                                placeholderText={startTime.toLocaleTimeString(
                                  'en-US',
                                  {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                  },
                                )}
                              />
                            )}
                          />
                          <div className="icon-box">
                            <TimeLine />
                          </div>
                        </div>
                      </DatePickerContainer>
                    </div>
                    {errors.targetTime && (
                      <p className="error-message">
                        {typeof errors.targetTime.message === 'string' &&
                          errors.targetTime.message}
                      </p>
                    )}
                  </div>
                )}

                {/* 안내문구 알림이 선택되었을 때만 TextArea 활성화 */}
                {item.key === '3' && selectedRadio === '3' && (
                  <div className="changearrivalTime-wrapper">
                    <div className="text-area-wrapper">
                      <TextArea
                        name="notificationTxt"
                        placeholder="알림 문구를 적어주세요."
                        register={register}
                        errors={
                          errors.notificationTxt?.message
                            ? [errors.notificationTxt.message as string]
                            : []
                        }
                      />
                    </div>
                  </div>
                )}
              </li>
            ))}
          </ul>

          {errors.radioBtnItems && (
            <p className="error-message">
              {typeof errors.radioBtnItems.message === 'string' &&
                errors.radioBtnItems.message}
            </p>
          )}
          <div className="btn-box">
            <button>발송</button>
          </div>
        </form>

        {isModalOpen && (
          <AlertModal
            handleConfirmClose={handleModalClose}
            confirmText={modalMessage}
            onClick={handleModalClose}
          />
        )}
      </AlertWrap>
    </Container>
  );
};

export default OrderStatusAlert;

//style
const Container = styled.div`
  padding: 0 2rem;
  .changearrivalTime-wrapper {
    width: 100%;
  }
  .error-message {
    color: ${(props) => props.theme.errorColor};
    font-size: 1.2rem;
    font-weight: 400;
    display: flex;
    margin: 1rem 1.7rem;
  }
`;

const AlertWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  li {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${(props) => props.theme.gray300};
    flex-wrap: wrap;
    .radio-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1.3rem 0.8rem;
      position: relative;
      input[type='radio'] {
        display: none;
      }
      label.text {
        font-size: 1.6rem;
        font-weight: 600;
        color: #555;
      }
      label.check-box {
        &::after {
          content: '';
          width: 2.2rem;
          height: 2.2rem;
          position: absolute;
          right: 0.8rem;
          top: 50%;
          transform: translateY(-50%);
          width: 2.2rem;
          height: 2.2rem;
          border-radius: 2.2rem;
          background: url('/assets/checkbox-nofill.svg');
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
        }
      }
      input[type='radio']:checked + label.check-box {
        &::after {
          background: url('/assets/checkbox-checked22px.svg');
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
        }
      }
    }
    .changearrivalTime {
      border-top: 1px solid ${(props) => props.theme.gray300};
    }
    .text-area-wrapper {
      border-top: 1px solid ${(props) => props.theme.gray300};
      padding: 2rem;
      background-color: rgb(250, 250, 250);
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      width: 100%;
      > div {
        width: 100%;
      }
    }
  }
  .btn-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 2rem 3.2rem;
    background-color: ${(props) => props.theme.textWhiteColor};
    button {
      width: 100%;
      background-color: ${(props) => props.theme.btnBlueColor};
      color: ${(props) => props.theme.textWhiteColor};
      padding: 1.7rem;
      border-radius: 1.2rem;
      border: 0;
      outline: none;
      font-size: 1.8rem;
      font-weight: 600;
    }
  }
`;

const CustomDatePicker = styled(DatePicker)``;

const DatePickerContainer = styled.div`
  padding: 2.4rem;
  background-color: ${(props) => props.theme.gray100};
  border-radius: 0.8rem;
  display: flex;
  gap: 4.8rem;
  align-items: center;
  width: 100%;
  span {
    font-size: 1.4rem;
    font-weight: 600;
    color: ${(props) => props.theme.joinLabelColor};
    line-height: 1.5rem;
  }
  .inner {
    position: relative;
    width: 100%;
    min-height: 2.4rem;
    display: flex;
    align-items: center;
    flex: 1;
    background-color: ${(props) => props.theme.textWhiteColor};
    padding: 1.3rem;
    border: 1px solid ${(props) => props.theme.searchBoxBorderedColor};
    border-radius: 0.8rem;
    .search-input {
      width: 100%;
      font-size: 1.4rem;
      font-weight: 400;
      background-color: inherit;
      border: 0px;
      outline: none;
      &::placeholder {
        color: ${(props) => props.theme.placeholderColor};
      }
    }
    .react-datepicker {
      font-size: 1.4rem;
      font-weight: 400;
      .react-datepicker__header {
        background-color: ${(props) => props.theme.textWhiteColor};
      }
      .react-datepicker__time-container
        .react-datepicker__time
        .react-datepicker__time-box {
        width: 20rem;
      }
      .react-datepicker__time-container {
        width: 20rem;
      }
      .react-datepicker__time-container
        .react-datepicker__time
        .react-datepicker__time-box
        ul.react-datepicker__time-list
        li.react-datepicker__time-list-item {
        width: 100%;
        height: 4.2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.8rem;
      }
      .react-datepicker__current-month,
      .react-datepicker-time__header,
      .react-datepicker-year-header {
        font-size: 1.4rem;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .react-datepicker__day-name,
      .react-datepicker__day,
      .react-datepicker__time-name {
        width: 3rem;
        line-height: 3rem;
      }
      .react-datepicker__day--selected,
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--selected,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--selected,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--selected,
      .react-datepicker__year-text--in-selecting-range,
      .react-datepicker__year-text--in-range {
        border-radius: 2rem;
        background-color: ${(props) => props.theme.btnBlueColor};
        color: ${(props) => props.theme.textWhiteColor};
      }
    }
    .react-datepicker-popper[data-placement='bottom']
      .react-datepicker__triangle {
      fill: ${(props) => props.theme.textWhiteColor};
      color: ${(props) => props.theme.textWhiteColor};
    }
    .icon-box {
      display: flex;
      position: absolute;
      top: 50%;
      right: 1rem;
      transform: translateY(-50%);
      svg {
        path {
          fill: #d7dbde;
        }
      }
    }
  }
`;
